<div class="pin-icon-div w-100 h-100 pt-4 fw-bolder text-left">
  <i
    class="fa fa-thumbtack"
    (click)="togglePin($event)"
    [ngClass]="{ visible: pinnedColumns[column] }"
  ></i>
  {{ column || headerName | title }}
</div>
